/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleDetail {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleDetail.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleDetail>): CostAnomalyGroupingRuleDetail {
        let obj = Object.assign(new CostAnomalyGroupingRuleDetail(), model);
        CostAnomalyGroupingRuleDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleDetail>): CostAnomalyGroupingRuleDetail {
        if (!model) return null;
        return CostAnomalyGroupingRuleDetail.newInstance(<CostAnomalyGroupingRuleDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleDetail) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleDetail): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.anomaly_count === undefined) {
            this.anomaly_count = 0;
        }
        if (this.cost_impact === undefined) {
            this.cost_impact = 0;
        }
        if (this.expected_cost === undefined) {
            this.expected_cost = 0;
        }
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
        if (typeof this.reject_until === "string") {
            this.reject_until = new Date(<string><any>this.reject_until);
        }
    }

    /**
     * Anomaly type for this detail row
     */
    anomaly_type: models.CostAnomalyType;

    /**
     * Product category wise anomaly count
     */
    anomaly_count: number;

    /**
     * Cost impact for this anomaly
     */
    cost_impact: number;

    /**
     * Expected cost for this anomaly
     */
    expected_cost: number;

    /**
     * Actual cost for this anomaly
     */
    actual_cost: number;

    /**
     * Service Account ID for this anomaly
     */
    service_account_id: string;

    /**
     * Product category, e.g. EC2
     */
    product_category: string;

    /**
     * Resource category, e.g. Compute
     */
    resource_category: string;

    /**
     * Resource identifier, e.g. ec2:i-123
     */
    resource_id: string;

    /**
     * Region for the resource, e.g. us-east-1
     */
    region: string;

    /**
     * Rejected Until time for the anomaly
     */
    reject_until: Date;

    /**
     * Rejected Reason
     */
    reject_reason: string;

}
